import {useMutation} from '@apollo/react-hooks';

import type {
    FormNextStepsSlackMessageSet as FormNextStepsSlackMessageSetMutation,
    FormNextStepsSlackMessageSetVariables as FormNextStepsSlackMessageSetMutationVariables,
} from 'nutshell-graphql-types';

import NEXT_STEPS_SLACK_MESSAGE_SET from '../mutations/set-next-steps-slack-message.graphql';

export function useSetNextStepsSlackMessage(): (arg1: {
    variables: FormNextStepsSlackMessageSetMutationVariables;
    onUpdateSuccess: (client?: any, mutationResults?: any) => void;
}) => Promise<any> {
    const [setNextStepsSlackMessage] = useMutation<
        FormNextStepsSlackMessageSetMutation,
        FormNextStepsSlackMessageSetMutationVariables
    >(NEXT_STEPS_SLACK_MESSAGE_SET);

    return (input: {
        variables: FormNextStepsSlackMessageSetMutationVariables;
        onUpdateSuccess: (client?: any, mutationResults?: any) => void;
    }) => {
        return setNextStepsSlackMessage({
            variables: input.variables,
            update: (proxy, mutationResults) => {
                input.onUpdateSuccess(proxy, mutationResults);
            },
        });
    };
}
